






























































































































import { Vue, Component } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { Picture } from '@/components/atoms';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ClockIcon from '@/components/icons/Clock.vue';
import { ILocation } from '@/models/location';
import CheckIcon from '@/components/icons/CheckGradient.vue';
import EmailOfferCreationPreviewService, {
  ISeamlessOfferCreation
} from '@/api/EmailOfferCreationPreviewService';
import HTTPStatus from '@/constants/httpStatus';

type FeedbackSlug = 'success' | 'alreadyUsed';

type FeedbackContent = {
  title: string;
  description: string;
  link: string;
  btnLabel: string;
  withIcon?: boolean;
};

enum EStepSlug {
  PREVIEW = 'preview',
  FEEDBACK = 'feedback'
}

@Component({
  components: {
    Typography,
    FilledButton,
    Page,
    ClockIcon,
    CheckIcon,
    Picture
  }
})
export default class EmailOfferCreationPreview extends Vue {
  service = new EmailOfferCreationPreviewService();
  code: string = '';
  data: ISeamlessOfferCreation | undefined = undefined;
  step: EStepSlug = EStepSlug.PREVIEW;
  creationSuccess: boolean = false;
  loading: boolean = false;
  buttonLoading: boolean = false;

  get isPreviewStep() {
    return this.step === EStepSlug.PREVIEW;
  }

  get feddbackContent() {
    const feddbackContentByStatus: Record<
      FeedbackSlug,
      FeedbackContent | null
    > = {
      success: {
        title: 'Offer’s successfully published!',
        description:
          'Your offer is now active and live on Twism app. You can see it on your dashboard under My Tools → Offers.',
        btnLabel: 'Go to My Offers',
        link: '/',
        withIcon: true
      },
      alreadyUsed: {
        title: 'This offer has already been published!',
        description:
          'This offer has already been published and is available in your dashboard under My Tools → Offers.',
        btnLabel: 'Go to My Offers',
        link: '/',
        withIcon: false
      }
    };

    if (this.creationSuccess) return feddbackContentByStatus.success;

    return feddbackContentByStatus.alreadyUsed;
  }

  locationsMap(locations: ILocation[]) {
    return locations.map(location => `📍 ${location.name}`).toString();
  }

  resizeEventHandler() {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty(
      '--email-offer-creation-preview-vh',
      `${vh}px`
    );
  }

  async sendOfferCreation() {
    this.buttonLoading = true;
    const { status } = await this.service.creationOffer(this.code);

    if (status === HTTPStatus.CREATED) {
      this.buttonLoading = false;
      this.creationSuccess = true;
      this.step = EStepSlug.FEEDBACK;
    }
  }

  goToDashboard() {
    this.$router.push('/');
  }

  onClickBtn() {
    if (this.isPreviewStep) {
      this.sendOfferCreation();
      return;
    }

    if (this.feddbackContent && this.feddbackContent.link) {
      this.$router.push(this.feddbackContent.link);
      return;
    }

    return this.$router.push('/');
  }

  async getData() {
    this.loading = true;
    const { data } = await this.service.getOfferCreationDetail(this.code);

    if (!data) {
      this.goToDashboard();
      return;
    }

    const { status } = data;

    if (status === 'done') this.step = EStepSlug.FEEDBACK;

    this.data = data;
    this.loading = false;
  }

  created() {
    this.code = this.$route.params.token;

    if (!this.code) {
      this.goToDashboard();
      return;
    }

    this.getData();
  }

  mounted() {
    this.resizeEventHandler();

    window.addEventListener('resize', this.resizeEventHandler);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEventHandler);
  }
}
